// Google Analytics e Search Console configuration

// Google Analytics 4 Configuration
export const GA_TRACKING_ID = 'G-XXXXXXXXXX'; // Substitua pelo seu ID do GA4

// Google Search Console Configuration
export const GSC_VERIFICATION_CODE = 'your-verification-code'; // Substitua pelo seu código de verificação

// Google Tag Manager Configuration
export const GTM_ID = 'GTM-XXXXXXX'; // Substitua pelo seu ID do GTM

// Função para inicializar Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && GA_TRACKING_ID) {
    // Carrega o script do Google Analytics
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script);

    // Inicializa o gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Função para rastrear eventos
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Função para rastrear visualizações de página
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Função para rastrear conversões
export const trackConversion = (conversionId, value, currency = 'BRL') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: conversionId,
      value: value,
      currency: currency,
    });
  }
};

// Eventos personalizados para o site
export const trackStoreView = (storeName, storeId) => {
  trackEvent('view_store', 'engagement', storeName, storeId);
};

export const trackStoreContact = (storeName, contactType) => {
  trackEvent('contact_store', 'engagement', `${storeName}_${contactType}`, 1);
};

export const trackEventRegistration = (eventName, eventId) => {
  trackEvent('register_event', 'conversion', eventName, eventId);
};

export const trackPromotionClick = (promotionName, storeName) => {
  trackEvent('click_promotion', 'engagement', `${promotionName}_${storeName}`, 1);
};

export const trackSearch = (searchTerm, resultsCount) => {
  trackEvent('search', 'engagement', searchTerm, resultsCount);
};

export const trackFilter = (filterType, filterValue) => {
  trackEvent('filter', 'engagement', `${filterType}_${filterValue}`, 1);
};

// Função para rastrear tempo na página
export const trackTimeOnPage = (pageName, timeSpent) => {
  trackEvent('time_on_page', 'engagement', pageName, timeSpent);
};

// Função para rastrear scroll depth
export const trackScrollDepth = (pageName, scrollDepth) => {
  trackEvent('scroll_depth', 'engagement', pageName, scrollDepth);
};

// Função para rastrear cliques em botões
export const trackButtonClick = (buttonName, pageName) => {
  trackEvent('button_click', 'engagement', `${buttonName}_${pageName}`, 1);
};

// Função para rastrear downloads
export const trackDownload = (fileName, fileType) => {
  trackEvent('file_download', 'engagement', `${fileName}_${fileType}`, 1);
};

// Função para rastrear formulários
export const trackFormSubmit = (formName, success) => {
  trackEvent('form_submit', 'conversion', formName, success ? 1 : 0);
};

// Função para rastrear erros
export const trackError = (errorMessage, errorLocation) => {
  trackEvent('error', 'exception', `${errorMessage}_${errorLocation}`, 1);
};

// Configurações de privacidade
export const privacyConfig = {
  anonymize_ip: true,
  allow_google_signals: false,
  allow_ad_personalization_signals: false,
  cookie_flags: 'SameSite=Strict;Secure',
};

// Função para configurar privacidade
export const configurePrivacy = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, privacyConfig);
  }
};
